import './background-image.css';
export default {
  "backgroundImage": "pf-v6-c-background-image",
  "dirRtl": "pf-v6-m-dir-rtl"
};